const DomainException = require('../../DomainException');
const errorcodes = require('../../errorcodes');

function normalizeLongIdentity(value) {
   if (value == null) return null;

   // DB projections may expose longs as strings while validated inputs are BigInt; normalize without weakening identity checks.
   try {
      return BigInt(value).toString();
   } catch (error) {
      return null;
   }
}

function selectPreferredSubmission(candidates) {
   if (!candidates || candidates.length === 0) return null;

   // A single null noSubmission is the local, not-yet-server-numbered attempt; multiple such attempts are ambiguous by design.
   const localCandidates = candidates.filter((submission) => submission.noSubmission == null);
   if (localCandidates.length > 1) {
      throw DomainException.New(errorcodes.MULTIPLE_LOCAL_TASK_SUBMISSIONS);
   }
   if (localCandidates.length === 1) return localCandidates[0];

   let preferred = null;
   let preferredNo = null;

   for (const submission of candidates) {
      const normalizedNo = normalizeLongIdentity(submission.noSubmission);
      if (normalizedNo == null) continue;

      const numericNo = BigInt(normalizedNo);
      if (preferred == null || numericNo > preferredNo) {
         preferred = submission;
         preferredNo = numericNo;
      }
   }

   return preferred;
}

module.exports = {
   normalizeLongIdentity,
   selectPreferredSubmission
};
